import React from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import './App.css';
import './styles/imports.css';
import 'typeface-roboto';
import Home from './views/home';
import ContentServ from './views/contentserv';
import OverviewCard from './components/overviewcard';
import KlassenOverview from './views/klassenoverview';
import Editor from './views/editor';
import Search from './views/search';
import history from './components/history';
import Theme from './components/theme';
import Download from './views/download';
import Gewinnspiel from './views/gewinnspiel';
import ImageList from './views/imagelist';
import Login from './views/login';
import Registration from './views/registration';
import Debug from './views/debug';
import Account from './views/account';
import ExerciseList from './views/exerciselist';
import ExerciseView from './views/exerciseview';
import CreateExercise from './views/createexercise';

class App extends React.Component {

  render() {
    const FALLBACK = () => <Redirect to="/" push />;
    const CONTENTSERV = (props) => <ContentServ klasse={props.match.params.klasse} theme={props.match.params.theme} type={props.match.params.type} history={props.history} />;
    const KLASSEN_OVERVIEW = (props) => <KlassenOverview klasse={props.match.params.klasse} history={props.history} />
    const SEARCH = (props) => <Search for={props.match.params.search} />
    const EXERCISELIST_MODERATOR = () => <ExerciseList hideShown />
    const EXERCISES_FT = (props) => <ExerciseList from={props.match.params.from} to={props.match.params.to} />
    const EXERCISES_FS = (props) => <ExerciseList from={props.match.params.from} to={props.match.params.from + props.match.params.size} />
    const EXERCISES_F = (props) => <ExerciseList from={props.match.params.from} />
    const EXERCISEVIEW = (props) => <ExerciseView id={props.match.params.id} />
    const GEWINNSPIEL = (props) => <Gewinnspiel klasse={props.match.params.klasse} history={props.history}/>

    const CARD_DEBUG = () => <OverviewCard title={"Klasse 5"} description={"Description for the Card"} buttons={[{ "name": "Name1", "href": "href1" }, { "name": "Name2", "href": "href2" }, { "name": "Name3", "href": "href3" }]} />;

    return (
      <Theme>
        <Router history={history}>
          <Switch>
            <Route
              path="/"
              component={Home}
              exact
            />
            <Route
              path="/login"
              component={Login}
              exact
            />
            <Route
              path="/register"
              component={Registration}
              exact
            />
            <Route
              path="/debug"
              component={Debug}
              exact
            />
            <Route
              path="/account"
              component={Account}
              exact
            />
            <Route
              path="/klasse/:klasse/theme/:theme/type/:type"
              component={CONTENTSERV}
              exact
            />
            <Route
              path="/klasse/:klasse"
              component={KLASSEN_OVERVIEW}
              exact
            />
            <Route
              path="/exercises"
              component={ExerciseList}
              exact
            />
            <Route
              path="/exercises/moderator"
              component={EXERCISELIST_MODERATOR}
              exact
            />
            <Route
              path="/exercises/from/:from/to/:to"
              component={EXERCISES_FT}
              exact
            />
            <Route
              path="/exercises/from/:from/size/:size"
              component={EXERCISES_FS}
              exact
            />
            <Route
              path="/exercises/from/:from"
              component={EXERCISES_F}
              exact
            />
            <Route
              path="/exercise/:id"
              component={EXERCISEVIEW}
              exact
            />
            <Route
              path="/createexercise"
              component={CreateExercise}
              exact
            />
            <Route
              path="/contentserv"
              exact
            ><Redirect to="/klasse/5/theme/thema1/type/aufgaben" /></Route>
            <Route
              path="/search/:search"
              component={SEARCH}
              exact
            />
            <Route
              path="/list"
              component={Search}
              exact
            />
            <Route
              path="/download"
              component={Download}
              exact
            />
            <Route
              path="/gewinnspiel/:klasse"
              component={GEWINNSPIEL}
              exact
            />
            {/* DEBUG STUFF */}
            <Route
              path="/imagelist/"
              component={ImageList}
            />
            <Route
              path="/card"
              component={CARD_DEBUG}
              exact
            />
            <Route
              path="/editor"
              component={Editor}
              exact
            />
            {/* FALLBACK */}
            <Route
              component={FALLBACK}
            />
          </Switch>
        </Router></Theme>
    );
  }

}

export default App;


/*
        // Klasse (5, 6, ...)
        $kl = $_GET["kl"];
        // Typ (Aufgaben / Uebungen)
        $type = $_GET["type"];
        // Thema (Ganze Zahlen, Koordinatensystem)
        $theme = $_GET["theme"];

*/
